module.exports = __webpack_public_path__ + "img/supervision_240.dbe92b1c.png";